import React from 'react';
import { useLocation } from 'react-router-dom';
import { ListItemText } from '@mui/material';

import useIsScreenerAllFacilitiesSelected, {
  SCREENER_ROUTES_WITH_ALL_FACILITIES_SUPPORT
} from '@/pages/CRM/Screener/Leads/AllLeads/hooks/useIsScreenerAllFacilitiesSelected';
import useNavigateToScreenerAllFacilities from '@/pages/CRM/Screener/Leads/AllLeads/hooks/useNavigateToScreenerAllFacilitites';
import { RoutePath } from '@/routes/RoutePath';

import { FacilitySelectorListItemButton } from './FacilitySelectorPopover';

interface CrmScreenerSelectAllButtonProps {
  setIsOpen: (value: React.SetStateAction<boolean>) => void;
  hide: boolean;
}

export default function CrmScreenerSelectAllButton(
  props: CrmScreenerSelectAllButtonProps
) {
  const { hide = false, setIsOpen } = props;
  const location = useLocation();
  const shouldShowSelectAllButton =
    SCREENER_ROUTES_WITH_ALL_FACILITIES_SUPPORT.includes(
      location.pathname as RoutePath
    );
  const isAllFacilitiesSelected = useIsScreenerAllFacilitiesSelected();
  const navigateToScreenerAllFacilities = useNavigateToScreenerAllFacilities(
    location.pathname as RoutePath
  );

  if (!shouldShowSelectAllButton || hide) {
    return null;
  }

  return (
    <FacilitySelectorListItemButton
      role="option"
      selected={isAllFacilitiesSelected}
      onClick={() => {
        navigateToScreenerAllFacilities();
        setIsOpen(false);
      }}
    >
      <ListItemText>Select All</ListItemText>
    </FacilitySelectorListItemButton>
  );
}
